import React, { useRef, useEffect, useState } from "react";
import "./JoinUsSection.css";
import { motion } from "framer-motion";
import Marquee from "react-fast-marquee";

const JoinUsSection = () => {
  const sectionRef = useRef(null);
  const [isInView, setIsInView] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsInView(true);
        } else {
          setIsInView(false);
        }
      },
      { threshold: 0.5 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <div
      ref={sectionRef}
      className="w-full h-[70vh] sm:h-screen responsive-background relative overflow-hidden"
    >
      <video
        autoPlay
        loop
        muted
        playsInline
        className="absolute top-0 left-0 w-full h-full object-cover -z-10"
      >
        <source src="/assets/join-us.webm" type="video/webm" />
        Your browser does not support the video tag.
      </video>
      <div className="background-overlay2 absolute top-0 left-0 w-full h-full -z-10 bg-cover bg-center bg-no-repeat"></div>

      {/* Marquee */}
      <div className="bg-black w-full border-y-4 border-green">
        <Marquee className="overflow-y-hidden">
          <p className="text-marqueText font-star-jedi-hol text-green">
            join us - Buy jaba the pepe -
          </p>
        </Marquee>
      </div>

      {/* Rotating Jaba */}
      <motion.div
        initial={{ rotate: 0 }}
        animate={{ rotate: isInView ? 360 : 0 }}
        transition={{
          duration: 10,
          repeat: isInView ? Infinity : 0,
          ease: "linear",
        }}
        className="w-[25%] sm:w-fit absolute top-[20%] sm:top-[15%] md:top-[20%] lg:top-40 left-[70%] sm:left-[70%] md:left-[65%] lg:left-[60%] xl:left-96"
      >
        <img
          src="/assets/space-pepe.png"
          alt="Jaba the Pepe"
          className="rotate"
        />
      </motion.div>

      {/* Left Side Sitting Jaba */}
      <motion.div
        initial={{ x: -100 }}
        animate={{ x: isInView ? 0 : -100 }}
        transition={{ duration: 1 }}
        className="max-w-[40%] sm:max-w-fit sm:w-fit absolute bottom-3 sm:bottom-6 left-4 sm:left-8"
      >
        <img
          src="/assets/how-to-buy-frog-4.webp"
          alt="Jaba the Pepe"
          className="float sm:w-1/2"
        />
      </motion.div>

      {/* Right Side Sitting Jaba */}
      <motion.div
        initial={{ x: 100 }}
        animate={{ x: isInView ? 0 : 100 }}
        transition={{ duration: 1 }}
        className="w-fit hidden xl:flex absolute bottom-4 lg:bottom-6 right-4 lg:right-8"
      >
        <img
          src="/assets/space-pepe-2.png"
          alt="Jaba the Pepe"
          className="float"
        />
      </motion.div>
    </div>
  );
};

export default JoinUsSection;
